<div class="link-component">
    <app-layout-control>
        <app-control-label top [control]="control" [caption]="caption()" />
        <dx-date-box #dx [showClearButton]="false" [useMaskBehavior]="true" [type]="type()" [value]="computedValue()" (onValueChanged)="onValueChanged($event)" (onBlur)="onTouched()"
            [isValid]="isValid" [interval]="timeInterval()" [min]="minDate()" [max]="maxDate()" [displayFormat]="displayFormat()">
        </dx-date-box>
        <app-control-supporting-text bottom [control]="control" [controlName]="caption()" [helpText]="helpText()" [isValid]="isValid" [calculateValidationText]="calculateValidationText()" />
    </app-layout-control>
</div>
